import Axios from "axios";

export async function deleteBid(bidId: number) {
  const response = await Axios.delete(`/api/bids/${bidId}/`);
  return response.data;
}
